import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SessionDetailsBin = ({ isPublished, linkToStep, sessionDetails, shareCatalogUrlMap }) => {
  const {
    consignContact,
    currency: { name: currencyName, code: currencyCode },
    creator,
    expertContact,
    saleAdmin,
    title,
    vat
  } = sessionDetails;

  const linkedFrom = 'step5';

  return (
    <Fragment>
      <Row className="mt-3">
        {/* 1st Column */}
        <Col xs={4}>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">
                {title}{' '}
                <Link
                  to={{
                    pathname: linkToStep(1),
                    state: { linkedFrom }
                  }}
                  aria-label="Edit"
                  className="ml-1 font-weight-normal"
                >
                  <FontAwesomeIcon icon="edit" className="btn-link" /> Edit Sale
                </Link>
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">
                Contacts
                <Link
                  to={{
                    pathname: linkToStep(1),
                    state: { linkedFrom }
                  }}
                  aria-label="Edit"
                  className="ml-1"
                >
                  <FontAwesomeIcon icon="edit" className="btn-link" />
                </Link>
              </p>
              <p className="mb-0">
                Consignment Contact: <span className="color-blue">{consignContact || ''}</span>
              </p>
              <p className="mb-0">
                Sale Administrator: <span className="color-blue">{saleAdmin || ''}</span>
              </p>
              <p className="mb-0">
                Expert Contact: <span className="color-blue">{expertContact || ''}</span>
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">
                Post Sale To
                <Link
                  to={{
                    pathname: linkToStep(1),
                    state: { linkedFrom }
                  }}
                  aria-label="Edit"
                  className="ml-1"
                >
                  <FontAwesomeIcon icon="edit" className="btn-link" />
                </Link>
              </p>
              {/* (dyouberg) Hardcoded for Buy Now */}
              <p className="mb-0">Invaluable: Available on Site / Buy Now</p>
            </Col>
          </Row>
          {isPublished && (
            <Row className="mb-3">
              <Col>
                <p className="mb-0">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      shareCatalogUrlMap[1]
                    )}`}
                    className="mb-0"
                  >
                    <FontAwesomeIcon icon={['fab', 'facebook']} />
                    &nbsp;Share on Facebook
                  </a>
                </p>
              </Col>
            </Row>
          )}
        </Col>

        {/* 2nd Column */}
        <Col xs={4}>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Currency</p>
              <p className="mb-0">
                {currencyName} ({currencyCode})
              </p>
              <p className="mb-0">+VAT: {vat === 0 ? 'No' : vat}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="font-weight-bold mb-0">Created By</p>
              <p className="mb-0">{creator}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SessionDetailsBin;
